import React, { useEffect } from "react";
import { Carousel } from "antd";
import { useSize } from "ahooks";
import { Img } from "../../ViewBuilderComponents/ImgV2/Img";
import { useSignal } from "@preact/signals-react";
import isBlank from "@sedan-utils/is-blank";
import style from "./C2.module.scss";
export var C2 = function C2(props) {
  var _size$height;
  // 唯一id 好区分是哪个C2
  var randomId = useSignal(Math.random().toString().slice(2));
  var currentSlideRef = useSignal(null);
  var size = useSize(currentSlideRef.value);
  var handleBeforeChange = function handleBeforeChange(from, to) {
    var currentSlide = document.querySelector(".c2-".concat(randomId.value, " .slick-slide[data-index=\"").concat(to, "\"]"));

    // 更新currentRef => useSize重新计算height
    currentSlideRef.value = currentSlide;
  };
  useEffect(function () {
    handleBeforeChange(0, 0);
  }, [props.image_list]);
  return /*#__PURE__*/React.createElement("div", {
    className: style.c2Box
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: (_size$height = size === null || size === void 0 ? void 0 : size.height) !== null && _size$height !== void 0 ? _size$height : "auto",
      overflow: "hidden"
    },
    className: "c2-".concat(randomId.value),
    key: "contentWrapper"
  }, /*#__PURE__*/React.createElement(Carousel, {
    autoplay: true,
    dotPosition: "top",
    className: style.c2CarouselBox
  }, isBlank(props.image_list) ? /*#__PURE__*/React.createElement(Img, {
    imgKey: "",
    className: "c2CarouselErrorImg"
  }) : props.image_list.map(function (url, index) {
    return /*#__PURE__*/React.createElement(Img, {
      imgKey: url.image,
      key: index,
      className: "c2CarouselImg"
    });
  }))));
};